import loadable from '@loadable/component'
import { Switch } from 'react-router'

import AuthRoute from 'components/App/Routes/AuthRoute'
import Trip404Page from 'tripPlanner/pages/Trip404Page'

const AddCustomFlight = loadable(
  () =>
    import(
      /* webpackChunkName: "TripPlannerWebViewAddCustomFlight" */ 'tripPlanner/pages/WebViews/components/AddCustomFlight/AddCustomFlight'
    ),
)

const AddItemsToTripView = loadable(
  () =>
    import(
      /* webpackChunkName: "TripPlannerWebViewAddItems" */ 'tripPlanner/pages/WebViews/components/AddItemsToTripView/AddItemsToTripView'
    ),
)

const FlightSearchView = loadable(
  () =>
    import(
      /* webpackChunkName: "TripPlannerWebViewFlightSearch" */ 'tripPlanner/pages/WebViews/components/FlightSearchView/FlightSearchView'
    ),
)

const MapView = loadable(
  () =>
    import(
      /* webpackChunkName: "TripPlannerWebViewMap" */ 'tripPlanner/pages/WebViews/components/MapView/MapView'
    ),
)

const SearchExperienceWebView = loadable(
  () =>
    import(
      /* webpackChunkName: "TripPlannerWebViewExperience" */ 'tripPlanner/pages/WebViews/components/SearchExperienceView/SearchExperienceView'
    ),
)

const SearchLEBookingView = loadable(
  () =>
    import(
      /* webpackChunkName: "TripPlannerWebViewLEBooking" */ 'tripPlanner/pages/WebViews/components/SearchLEBookingView/SearchLEBookingView'
    ),
)

const SearchTourOrCruiseView = loadable(
  () =>
    import(
      /* webpackChunkName: "TripPlannerWebViewTours" */ 'tripPlanner/pages/WebViews/components/SearchTourOrCruiseView/SearchTourOrCruiseView'
    ),
)

const ShareTripWebView = loadable(
  () =>
    import(
      /* webpackChunkName: "TripPlannerWebViewShareTrip" */ 'tripPlanner/pages/WebViews/components/ShareTripView/ShareTripView'
    ),
)

const EditCustomFlight = loadable(
  () =>
    import(
      /* webpackChunkName: "TripPlannerWebViewAddCustomFlight" */ 'tripPlanner/pages/WebViews/components/EditCustomFlight/EditCustomFlight'
    ),
)

const TourAndCruiseItemSummaryView = loadable(
  () =>
    import(
      /* webpackChunkName: "TripPlannerWebViewTourAndCruiseItemSummary" */ 'tripPlanner/pages/WebViews/components/TourAndCruiseItemSummaryView/TourAndCruiseItemSummaryView'
    ),
)

const ExperienceItemSummaryView = loadable(
  () =>
    import(
      /* webpackChunkName: "TripPlannerExperienceItemSummary" */ 'tripPlanner/pages/WebViews/components/ExperienceItemSummaryView/ExperienceItemSummaryView'
    ),
)

const SavedLandingView = loadable(
  () =>
    import(
      /* webpackChunkName: "TripPlannerSavedLandingView" */ 'tripPlanner/pages/WebViews/components/SavedViewWebView/SavedViewWebView'
    ),
)

function WebViewRoutes() {
  return (
    <Switch>
      <AuthRoute
        path="/:regionCode/trip-planner/webView/:tripId/search-experience"
        component={SearchExperienceWebView}
      />
      <AuthRoute
        path="/:regionCode/trip-planner/webView/:tripId/share-trip"
        component={ShareTripWebView}
      />
      <AuthRoute
        path="/:regionCode/trip-planner/webView/:tripId/search-flights"
        component={FlightSearchView}
      />
      <AuthRoute
        path="/:regionCode/trip-planner/webView/:tripId/search-tours-or-cruises"
        component={SearchTourOrCruiseView}
      />
      <AuthRoute
        path="/:regionCode/trip-planner/webView/:tripId/search-le-booking"
        component={SearchLEBookingView}
      />
      <AuthRoute
        path="/:regionCode/trip-planner/webView/:tripId/add-to-trip"
        component={AddItemsToTripView}
      />
      <AuthRoute
        path="/:regionCode/trip-planner/webView/:tripId/map"
        component={MapView}
      />
      <AuthRoute
        path="/:regionCode/trip-planner/webView/:tripId/custom-flight"
        component={AddCustomFlight}
      />
      <AuthRoute
        path="/:regionCode/trip-planner/webView/:tripId/edit-custom-flight/:itemId"
        component={EditCustomFlight}
      />
      <AuthRoute
        path="/:regionCode/trip-planner/webView/:tripId/tour-cruise-summary/:itemId"
        component={TourAndCruiseItemSummaryView}
      />
      <AuthRoute
        path="/:regionCode/trip-planner/webView/:tripId/experience-summary/:itemId"
        component={ExperienceItemSummaryView}
      />
      <AuthRoute
        path="/:regionCode/trip-planner/webView/saved"
        component={SavedLandingView}
      />
      <Trip404Page />
    </Switch>
  )
}

export default WebViewRoutes
